import { useState, useEffect } from 'react';
import AuthShell from './AuthShell';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Label } from '../ui/label';

const ResetPasswordScreen = ({ api, onDone }) => {
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setToken(new URLSearchParams(window.location.search).get('token') || '');
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) return setError('Password must be at least 8 characters');
    if (password !== confirm) return setError('Passwords don’t match');
    setIsLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      setDone(true);
    } catch (err) {
      setError(err.message || 'Could not reset password');
    } finally {
      setIsLoading(false);
    }
  };

  if (done) {
    return (
      <AuthShell title="Password updated">
        <div className="text-center space-y-4">
          <p className="text-sm text-muted-foreground">Your password has been changed.</p>
          <Button onClick={() => onDone('login')} className="w-full">Go to sign in</Button>
        </div>
      </AuthShell>
    );
  }

  if (!token) {
    return (
      <AuthShell title="Reset password">
        <div className="text-center space-y-4">
          <p className="text-sm text-destructive">This reset link is missing its token.</p>
          <Button onClick={() => onDone('forgot')} className="w-full">Request a new link</Button>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Choose a new password">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="password">New password</Label>
          <Input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} required autoFocus />
          <p className="text-xs text-muted-foreground">At least 8 characters.</p>
        </div>
        <div className="space-y-2">
          <Label htmlFor="confirm">Confirm password</Label>
          <Input id="confirm" type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required />
        </div>
        {error && <div className="text-sm text-destructive bg-destructive/10 p-3 rounded-md text-center">{error}</div>}
        <Button type="submit" disabled={isLoading} className="w-full">
          {isLoading ? 'Saving…' : 'Update password'}
        </Button>
      </form>
    </AuthShell>
  );
};

export default ResetPasswordScreen;
